import { TAB } from '../Layout/NavBar'
import React from 'react'

const KPI = ({ auth }: { auth: boolean}) => !auth 
?   <> 
        Welcome to the <strong>TWITTER GROWTH DASHBOARD</strong> <br/>
        Use it to grow your audience and easily monetize your products.
    </>
:   <>
        The KPIs are fully responsive, mobile first UI <br/>
        To track the ENGAGEMENT & REACH of your recent tweets.
    </>

const Growth = ({ auth }: { auth: boolean}) =>  !auth 
?   <> 
        To learn how to maximize the value of the Dashboard <br/>
        Download the <a href='/Twitter_Growth_Routine.pdf' target='_blank'><strong>ULTIMATE GROWTH ROUTINE.</strong></a>
    </>
:   <>
        The Growth view gives you actionable data to make informed decisions<br/>
        Learn insights about WHAT TO TWEET and with WHO TO ENGAGE.
    </>

const HeatMap = ({ auth }: { auth: boolean}) =>  !auth 
?   <> 
        You can <strong>CONNECT YOUR TWITTER ACCOUNT</strong> from the Menu NavBar <br/>
        Learn how your recent activity follows a growth strategy.
    </>
:   <>
        Schedule a FREE 30 minute 1-on-1 meeting in my Calendly <br/>
        Let's discuss your Twitter Strategy and optimize the time you invest in it.
    </>


const notificationStyle = { marginLeft:'auto', marginRight:'auto', textAlign:'center', borderRadius:15 } as const
export const Notification = ({ tab, auth }: { tab:TAB, auth:boolean }) => <div 
    className="notification is-link" 
    style={{...notificationStyle, maxWidth: !auth ? 1150 : tab !== 'KPI' ? 720 : 540 }}
>
    { tab === 'KPI' ? <KPI auth={auth} /> : null }
    { tab === 'GROWTH' ? <Growth auth={auth} /> : null }
    { tab === 'HEATMAP' ? <HeatMap auth={auth} /> : null }
</div>
